import React from "react";
import moment from "moment";
import "./status-training.scss";

const statusTypes = {
  1: "#C4C4C4",
  2: "#81CC5E",
  3: "#4594CC"
};

const StatusTraining = ({ start, end, day }) => {
  const format = "HH:mm:ss";
  const now = moment().format(format);
  const time = moment(now, format),
    beforeTime = moment(start, format),
    afterTime = moment(end, format);

  const dayNow = moment().format("YYYY-MM-DD");
  const dayX = moment(day).format("YYYY-MM-DD");

  const after = moment(dayNow).isAfter(dayX);
  const before = moment(dayNow).isBefore(dayX);
  const today = moment(dayX).isSame(dayNow);

  if (after && day) {
    return (
      <span className="todayDot" style={{ backgroundColor: statusTypes[1] }} />
    );
  } else if (before && day) {
    return (
      <span className="todayDot" style={{ backgroundColor: statusTypes[3] }} />
    );
  } else if (today && day) {
    return (
      <span>
        {time.isBetween(beforeTime, afterTime) ? (
          <span
            className="todayDot"
            style={{ backgroundColor: statusTypes[2] }}
          />
        ) : null}
        {time.isAfter(afterTime) ? (
          <span
            className="todayDot"
            style={{ backgroundColor: statusTypes[1] }}
          />
        ) : null}
        {time.isBefore(beforeTime) ? (
          <span
            className="todayDot"
            style={{ backgroundColor: statusTypes[3] }}
          />
        ) : null}
      </span>
    );
  } else return null;
};

export default StatusTraining;
